export default __webpack_public_path__ + "search-examples-mapbox-mapview-category-1200-50fb6ad2795da78c5c1e58e4425d6749.png";